import angular from "angular"
import formRoutes from "./form_routes"

const no_selection_template = require("file-loader!@/components/others/no_selection.template.html")

const service = [
  "$mdDialog",
  function($mdDialog) {
    var self = this

    self.form_routes = formRoutes

    self.messages_routes = { no_selection: no_selection_template }

    //context debe presentar modelName y actionName
    //locals debe presentar saveCallback y models (en los casos que correspondan)
    self.showPopup = function($event, context, locals) {
      var ev = $event
      var config = {
        controller: null,
        templateUrl: null,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }
      config.controller = self.form_routes[context.modelName][context.actionName]["controller"]
      config.templateUrl = self.form_routes[context.modelName][context.actionName]["templateUrl"]
      config.locals = locals
      $mdDialog.show(config)
    }

    self.showPopupSimple = function($event, context) {
      var ev = $event

      var config = {
        controller: context.controller,
        templateUrl: context.templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }

      $mdDialog.show(config)
    }

    self.showAlert = function($event, message) {
      var ev = $event

      var config = {
        controller: [
          "$scope",
          function($scope) {
            $scope.close = function() {
              $mdDialog.hide()
            }
          }
        ],
        templateUrl: self.messages_routes[message],
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }

      $mdDialog.show(config)
    }

    return {
      showPopup: self.showPopup,
      showAlert: self.showAlert,
      showPopupSimple: self.showPopupSimple
    }
  }
]

angular.module("appModule").service("formularioService", service)
